
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","data-name":"Layer 1","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 5c0-1.654 1.346-3 3-3V1a1 1 0 112 0v1h.268a3.01 3.01 0 012.598 1.499 1 1 0 11-1.73 1.002A1.003 1.003 0 0013.269 4h-2.268a1 1 0 00-1 1 .77.77 0 00.645.761l3.04.506A2.763 2.763 0 0116.001 9c0 1.654-1.346 3-3 3v1a1 1 0 11-2 0v-1h-.268a3.01 3.01 0 01-2.598-1.499 1 1 0 111.73-1.002c.179.31.511.501.867.501H13a1 1 0 001-1 .77.77 0 00-.645-.761l-3.04-.506A2.763 2.763 0 018 5zm11.102-2H19a1 1 0 100 2h.102a1.9 1.9 0 011.419 3.159l-7.268 8.177A.998.998 0 0013 17v4l-2-1.5V17a.998.998 0 00-.253-.664L3.479 8.158A1.9 1.9 0 014.898 5H5a1 1 0 100-2h-.102A3.903 3.903 0 001 6.898c0 .955.35 1.875.985 2.589L9 17.38V20a1 1 0 00.4.8l4 3a.995.995 0 001.047.095c.339-.17.553-.516.553-.895v-5.62l7.015-7.892A3.893 3.893 0 0023 6.898 3.903 3.903 0 0019.102 3z"}})])
          )
        }
      }
    